import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import VueTables from 'vue-tables-2-premium'
import Paginate from 'vuejs-paginate'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import VueClip from 'vue-clip'
import DefaultLayout from './layouts/Default'
import WelcomeLayout from './layouts/Welcome.vue'

const VueInputMask = require('vue-inputmask').default

Vue.component('default', DefaultLayout)
Vue.component('welcome', WelcomeLayout)
Vue.component('paginate', Paginate)

Vue.use(Vuelidate)
Vue.use(Notifications)
Vue.use(VueTables.ClientTable)
Vue.use(VueInputMask)
Vue.use(VModal)
Vue.use(VTooltip, {
  defaultHtml: false,
})
Vue.use(VueClip)
